"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var CounterController = /** @class */ (function (_super) {
    __extends(CounterController, _super);
    function CounterController($scope, $interpolate, book) {
        'ngInject';
        var _this = _super.call(this, $scope, book) || this;
        _this.$interpolate = $interpolate;
        _this.setValue();
        $scope.$watch(function () { return book; }, function () { _this.setValue(); }, true);
        return _this;
    }
    CounterController.prototype.setValue = function () {
        var count = 0;
        for (var _i = 0, _a = this.counterOptions.conditions; _i < _a.length; _i++) {
            var condition = _a[_i];
            if (this.$interpolate("{{" + condition + "}}")(this.book) === 'true') {
                count++;
            }
        }
        var context = Object.assign({}, this.book, { math: Math });
        var max = this.$interpolate("{{" + this.counterOptions.max + "}}")(context);
        var min = this.$interpolate("{{" + this.counterOptions.min + "}}")(context);
        this.form.setValidity('required', count >= min && count <= max);
        this.form.value = count;
        this.book.set(this.prefix, this.id, this.form.value);
    };
    return CounterController;
}(form_1.FormOptionController));
exports.CounterController = CounterController;
function CounterDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/counter.html',
        controller: CounterController,
        controllerAs: 'counterCtrl'
    };
}
exports.CounterDirective = CounterDirective;
